const MetasliderIcon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	width="20px" height="20px" viewBox="0 0 20 20" className={'dashicon metaslider-icon'}>
	<path d="M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10s10-4.477,10-10S15.523,0,10,0z M2.95,12.667l5.796-7.218
	l0.979,1.049l-4.817,6.169H2.95z M12.735,12.667l-2.5-3.015l0.959-1.25l3.46,4.265H12.735z M15.013,12.667l-3.838-4.915
	l-3.838,4.915H5.378l5.777-7.382l5.895,7.382H15.013z"/>
</svg>

export default MetasliderIcon



// WEBPACK FOOTER //
// ./src/admin/assets/js/gutenberg/components/metaslider-icon.js